import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-documents" }
const _hoisted_2 = { class: "ui-toggle-container" }
const _hoisted_3 = { class: "ui-toggle" }
const _hoisted_4 = { class: "documents-container" }
const _hoisted_5 = {
  key: 0,
  class: "no-files"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "document-form" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "delete-modal-content" }
const _hoisted_10 = { class: "icon-container" }
const _hoisted_11 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DocumentEdit = _resolveComponent("DocumentEdit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      id: "search-user-documents",
      class: "style-standard",
      searchOpen: "",
      onFilterSearch: _ctx.inputSearchTerm
    }, null, 8, ["onFilterSearch"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass({ selected: _ctx.selectedUiType === 'grid' }),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleUi && _ctx.toggleUi(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: "th-large"
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass({ selected: _ctx.selectedUiType === 'table' }),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleUi && _ctx.toggleUi(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: "list-ul"
          })
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.isFetching && !_ctx.allDocuments.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/img/file_management.svg'),
              alt: ""
            }, null, 8, _hoisted_6),
            _cache[7] || (_cache[7] = _createElementVNode("h4", null, "No Documents Found", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "Add a document for the user if required.", -1))
          ]))
        : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
            key: 1,
            tableHeadings: _ctx.tableHeadings,
            preparedDocs: _ctx.preparedDocs,
            documents: _ctx.allDocuments,
            documentContents: _ctx.documentContents,
            selectedDocuments: _ctx.selectedDocuments,
            deselectedDocuments: _ctx.deselectedDocuments,
            totalRows: _ctx.totalRows,
            actionsChip: _ctx.documentActionsChip,
            headingsData: _ctx.headingsData,
            sortOrder: _ctx.sortOrder,
            selectAll: _ctx.selectAll,
            onToggleAllRows: _ctx.toggleAllRows,
            onToggleActionsChip: _ctx.toggleActionsChip,
            onBulkDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleToggleDeleteModal(true))),
            onBulkDownload: _ctx.handleBulkDownload,
            onToggleCheckbox: _ctx.toggleCheckbox,
            onViewDocument: _ctx.viewDocument,
            onClickCell: _ctx.handleClickCell,
            onHandleClickSort: _ctx.handleClickSort
          }, null, 40, ["tableHeadings", "preparedDocs", "documents", "documentContents", "selectedDocuments", "deselectedDocuments", "totalRows", "actionsChip", "headingsData", "sortOrder", "selectAll", "onToggleAllRows", "onToggleActionsChip", "onBulkDownload", "onToggleCheckbox", "onViewDocument", "onClickCell", "onHandleClickSort"]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event)),
        title: "documents.upload",
        subTitle: "common.add-files"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DocumentEdit, {
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model) = $event)),
            editable: false,
            onValidUpdate: _ctx.handleValidUpdate,
            onToggleDeleteModal: _ctx.handleToggleDeleteModal,
            onCloseModel: _ctx.handleCloseModal
          }, null, 8, ["modelValue", "onValidUpdate", "onToggleDeleteModal", "onCloseModel"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              text: "common.cancel-action",
              size: "sm",
              variant: "secondary",
              onClick: _ctx.cancelDocumentChanges
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              text: "documents.save",
              size: "sm",
              disabled: !_ctx.isValid,
              onClick: _ctx.handleSave
            }, null, 8, ["disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showDeleteModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDeleteModal) = $event))
    }, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "delete-modal" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_font_awesome_icon, {
              class: "icon",
              icon: "exclamation-triangle",
              size: "3x"
            })
          ]),
          _createElementVNode("h4", null, [
            _createVNode(_component_TranslatedText, { path: "prompts.warning" })
          ]),
          _createVNode(_component_TranslatedText, { path: "documents.delete-warning" })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            text: "common.cancel-action",
            size: "sm",
            variant: "secondary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleToggleDeleteModal(false)))
          }),
          _createVNode(_component_Button, {
            text: "common.delete",
            size: "sm",
            variant: "error",
            onClick: _ctx.handleDeleteFile
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}